import * as React from 'react';
import { Icon, Input, Dropdown, Checkbox, Button, Grid, Modal } from 'semantic-ui-react';
import UpdateList from '../sys/updateList';
import { default as Renderers } from '../sys/columns';
import OAuth, { OAuthClientStatus, VodDataExportView } from '../api';
import * as ReactTooltip from 'react-tooltip';
import TestDetailsView from './monitoring/testDetails';
import { NavLink } from 'react-router-dom';

const _ = require('lodash');
const FontAwesome = require('react-fontawesome');

class State {
    host: string;
    imgurl: string;
    columns: Array<string>;
    newColumns: any;
    groupby: Array<string>;
    showAssets: boolean;
    censusFilter: string | null;
    streamId: number;
    streamName: string;
    streamResult: string;
    streamMessage: string;
    streamFilter: string;
    url: string;
    showTestDetailsWindow: boolean;
    statusFilter ?: any;
    formatFilter ?: any;
    showTopLevel ?: boolean;
    refreshRate ?: number;
    tempRefreshRate ?: number;
    mode?: string;
    sharedManifest ?: boolean;
    streamType ?: string;
    masterFile ?: boolean;
    treeOrder ?: boolean;
    firstLoad ?: boolean;
    eventTypeFilter: string[];
    eventTypeFilterText: string[];
    eventTypeFilterAll: boolean;
    eventTypeClicked: boolean;
    showModal: boolean;
    audioEnabled ?: boolean;
    videoEnabled ?: boolean;
    pixelEnabled ?: boolean;
}

interface Props {
    location ?: any;
}

export default class VodCensusView extends React.Component<Props, State> {
    
    protected columnSets = {
        // the underscore set are always added to the View at the beginning.
        _: [{
            id: 'buttonMenu',
            width: 10,
            align: 'center',
            sortable: false
            // Cell: (props: any) => this.buttonRenderer(props)
        }, {
            id: 'statusIcon',
            width: 40,
            align: 'center',
            sortable: false,
            Cell: (props: any) => this.statusRenderer(props) // Pass/Fail/Error Indicator
        }, {
            Header: () => this.headerRenderer('Name', 'Name of the stream'),
            accessor: 'stream.name',
            id: 'streamName',
            width: 400,
            resizable: true,
            aggregate: 'blank',
            sortable: false,
            Cell: (props: any) => this.assetNameRenderer(props)
            }
        ],
        Summary: [
            {
                Header: () => this.headerRenderer('Stream Type', 'ABR format of the stream'),
                accessor: 'stream.streamType',
                id: 'streamType',
                width: 250,
                resizable: false,
                aggregate: 'blank',
                align: 'center',
                sortable: false,
                Cell: (props: any) => this.streamTypeRenderer(props)
            }, {
                Header: () => this.headerRenderer('Test Duration', 'Active time of test session (dd:hh:mm:ss)'),
                accessor: 'stream.statistics.summary',
                id: 'duration',
                type: 'timestamp.calendar',
                width: 280,
                align: 'center',
                Cell: (props: any) => this.calculateTimeout(props)
            }
        ],
        Accessibility: [
            {
                Header: () => this.headerRenderer((<span>Server <br/>Changes</span>), '[Manifest] / [Media] <br /> Type: Count <br /> Period: Session lifetime <br /> Detail: Session moved to different server IP'),
                accessor: 'stream.statistics.connection',
                id: 'serverChanges',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                sortable: false,
                Cell: (props: any) => this.serverChangeRenderer(props)
            }, {
                Header: () => this.headerRenderer((<span>DNS<br/>Time<br/>(ms)</span>), 'Type: Timed <br /> Period: Most recent <br /> Detail: DNS resolution time'),
                accessor: 'stream.statistics.connection.dns.time.current', // DNS-TIME-EXCEED
                id: 'dnsTime',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonTimeRenderer(props, 0x00000040, 0),
            }, {
                Header: () => this.headerRenderer((<span>DNS Time<br/>Error</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail: DNS queries exceeding time threshold'),
                accessor: 'stream.statistics.connection.dns.timeErrors', // DNS-TIME-COUNT-15M
                id: 'dnsTimeError15M',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarm0Renderer(props, 0x00000020, 0),
            }, {
                Header: () => this.headerRenderer((<span>DNS Query<br/>Failure</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail: DNS query failure'),
                accessor: 'stream.statistics.connection.dns.errors', // DNS-FAIL-COUNT-15M
                id: 'dnsQueryFailure15M',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarm0Renderer(props, 0x00200000, 0),
            }, {
                Header: () => this.headerRenderer((<span>TCP<br/>Connection<br/>Time<br/>(ms)</span>), 'Type: Timed <br /> Period: Most recent <br /> Detail: TCP session establish with server'),
                accessor: 'stream.statistics.connection.time.current', // CONN-TIME-EXCEED
                id: 'tcpConnectionTime',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonTimeRenderer(props, 0x00000008, 0)
            }, {
                Header: () => this.headerRenderer((<span>TCP<br/>Connection<br/>Time<br/>Error</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail: TCP connection attempts exceeding time threshold'),
                accessor: 'stream.statistics.connection.timeErrors', // CONN-TIME-COUNT-15M
                id: 'tcpConnectionTime15M',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarm0Renderer(props, 0x00000004, 0)
            }, {
                Header: () => this.headerRenderer((<span>TCP<br/>Connection<br/>Failure</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail: TCP connection errors'),
                accessor: 'stream.statistics.connection.errors', // CONN-FAIL-COUNT-15M
                id: 'tcpConnectionFailure15M',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x08000000, 1, false)
            }, {
                Header: (h: any) => (
                    <div>
                        <div className="title">HTTP Codes</div>
                        <div className="http totals -header">
                            <div className="http2xxBox-empty">{this.headerRenderer('2xx', 'Type: Count <br /> Period: Session lifetime <br /> Detail: HTTP 2xx (Success) response')}</div>
                            <div className="http3xxBox-empty">{this.headerRenderer('3xx', 'Type: Count <br /> Period: Session lifetime <br /> Detail: HTTP 3xx (Redirect) response')}</div>
                            <div className="http4xxBox-empty">{this.headerRenderer('4xx', 'Type: Count <br /> Period: Session lifetime <br /> Detail: HTTP 4xx (Client error) response')}</div>
                            <div className="http5xxBox-empty">{this.headerRenderer('5xx', 'Type: Count <br /> Period: Session lifetime <br /> Detail: HTTP 5xx (Server error) response')}</div>
                            <div className="outline">{this.headerRenderer('CL', 'Type: Count <br /> Period: Session lifetime <br /> Detail: Close connections - incremented for each explicity close')}</div>
                            <div className="outline">{this.headerRenderer('OT', 'Type: Count <br /> Period: Session lifetime <br /> Detail: Connection errors other than open/close')}</div>
                        </div>
                    </div>
                ),
                accessor: 'stream.statistics.http',
                id: 'httpStatusCodes',
                width: 500,
                align: 'left',
                className: 'group-first group-last',
                aggregate: 'blank',
                sortable: false,
                Cell: (props: any) => this.httpCodesRenderer(props, props.value)
            }, {
                Header: () => this.headerRenderer((<span>HTTP 4xx<br/>Error</span>), 'Type: Count of responses  <br /> Period: Session Lifetime  <br /> Detail: HTTP 4xx response received'),
                accessor: 'stream.statistics.http.hsce4xxTotal', // HTTP4-COUNT-15M
                id: 'http4XxError15M',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00080000, 0, false)
            }, {
                Header: () => this.headerRenderer((<span>HTTP 5xx<br/>Error</span>), 'Type: Count of responses <br /> Period: Session Lifetime  <br /> Detail: HTTP 5xx response received'),
                accessor: 'stream.statistics.http.hsse5xxTotal', // HTTP5-COUNT-15M
                id: 'http5XxError15M',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00020000, 0, false)
            }, {
                Header: () => this.headerRenderer((<span>MIME<br/>Header<br/>Error</span>), 'Type: Count of occurrences  <br /> Period: Session Lifetime <br /> Detail: Unexpected or not present MIME Header fields in response'),
                accessor: 'stream.statistics.connection.mimeHeaderErrors', // HTTP-MIME
                id: 'mimeHeaderErrors',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00002000, 1, true)
            }, {
                // tslint:disable-next-line:max-line-length
                Header: () => this.headerRenderer((<span>Expired<br/>Asset<br/>Still<br/>Available</span>), 'Type: Count <br /> Period: Session <br /> Detail: Asset is being tested to ensure that it is no longer available, but it is accessible using the configured playback URL.'),
                accessor: 'stream.statistics.vod.expirationErr', // VOD-EXPIRATION-ERR
                id: 'vodExpirationErr',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.passFailRenderer(props, 'SYN-VOD-EXPIRATION-ERR')
            }
        ],
        ['ABR Protocol']: [
            {
                Header: () => this.headerRenderer((<span>Playlist<br/>Unavailable</span>), 'Type: Count of occurrences<br/>Period: Session Lifetime<br/>Detail: Playlist file unavailable for download after configured number of retries'),
                accessor: 'stream.statistics.files.manifest.unaErr', // PLAYLIST-UNAVAIL
                id: 'playlistUnavailable',
                width: 95,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00000200, 1, false)
            }, {
                Header: () => this.headerRenderer((<span>Playlist<br/>File<br/>Error</span>), 'Type: Count of occurrences <br /> Period: Session Lifetime <br /> Detail: Mandatory fields not present in playlist'),
                accessor: 'stream.statistics.files.manifest.fileErr', // PLAYLIST-COUNT-15M
                id: 'playlistFileError',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00200000, 1, false)
            }, {
                Header: () => this.headerRenderer((<span>Asset<br/>Type<br/>Incorrect</span>), 'Type: Count <br /> Period: Session <br /> Detail: Asset type is expected to be video on demand, but the manifest is not formatted correctly.'),
                accessor: 'stream.statistics.vod.assetTypeErr', // VOD-ASSETTYPE-ERR
                id: 'vodAssetTypeErr',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.passFailRenderer(props, 'SYN-VOD-ASSET-TYPE-ERR')
            }, {
                Header: () => this.headerRenderer((<span>Variant<br/>Count<br/>Error</span>), 'Type: Count of occurrences <br /> Period: Session Lifetime <br /> Detail: Number of playlists where expected profiles differs from the actual value'),
                accessor: 'stream.statistics.files.manifest.profCntErr', // VARIANT-COUNT-15M
                id: 'variantCountError',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x80000000, 1, false)
            }, {
                Header: () => this.headerRenderer((<span>Variant<br/>Required<br/>Error</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail: Playlist does not contain all expected variants'),
                accessor: 'stream.statistics.files.manifest.varReqErr', // VAR-REQ
                id: 'variantRequiredError',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkVariant(props, 0x00000004, 1, 'total')
            }, {
                Header: () => this.headerRenderer((<span>Media File<br/>Unavailable<br/>Error</span>), 'Type: Count <br /> Period: Session <br /> Detail: Media file unavailable for download after multiple retries'),
                accessor: 'stream.statistics.files.media.unaErr', // MF-UNAVAIL-COUNT
                id: 'mediaFileUnavailable',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkMaster(props, 0x00000100, 1)
            }, {
                Header: () => this.headerRenderer((<span>Media File<br/>Duration Error</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail: Media file playback duration exceed the specified threshold'),
                accessor: 'stream.statistics.files.media.durationMaxErrors', // MF-DUR-MAX-COUNT-15M
                id: 'mediaFileDurationError15M',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkMaster(props, 0x00008000, 0)
            }, {
                // tslint:disable-next-line:max-line-length
                Header: () => this.headerRenderer((<span>Content<br/>Duration<br/>Error</span>), 'Type: Count <br /> Period: Session <br /> Detail: Media content exceeds the configured duration on the VOD Asset Alias by more than the configured deviation percentage.'),
                accessor: 'stream.statistics.vod.durationErr', // VOD-DURATION-ERR
                id: 'vodDurationError',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.passFailRenderer(props, 'SYN-VOD-DURATION-ERR')
            }, {
                Header: () => this.headerRenderer((<span>Media File<br/>Bitrate Error</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail: Media file bitrate does not match the advertised value'),
                accessor: 'stream.statistics.files.media.bitrateErrors', // MF-BR-MAX-15M
                id: 'mediaFileBitrateError15M',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkMaster(props, 0x20000000, 1)
            // }, {
            //     Header: () => this.headerRenderer((<span>Media File<br/>Time Not<br/>Aligned</span>), 'Type: Count <br /> Period: Session lifetime <br /> Detail: Media file alignment timing incorrect'),
            //     accessor: 'stream.statistics.files.media.mftaCntErr', // MF-TIME-ALIGN // Not supported in VOD mode
            //     id: 'mediaFileTimeNotAligned',
            //     width: 100,
            //     align: 'right',
            //     aggregate: 'blank',
            //     Cell: (props: any) => this.checkNotMaster(props, 0x00010000, 0)
            }, {
                Header: () => this.headerRenderer((<span>I-Frame<br/>Missing</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail: Each media file that does not start with an I-Frame'),
                accessor: 'stream.statistics.qoe.errors.frameStartErr', // MF-IDR-FRAME-COUNT-WIN
                id: 'iFrameMissing',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkMaster(props, 0x00000002, 0)
            }, {
                Header: () => this.headerRenderer((<span>Audio<br/>Not<br/>Present</span>), 'Type: Count, Apple & MPEG DASH MPEG-2 media only <br /> Period: Session <br /> Detail:  Media files contains no audio PID'),
                accessor: 'stream.statistics.files.media.audio.NPErrors', // NO-AUDIO
                id: 'audioNotPresent',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                sortable: false,
                Cell: (props: any) => this.checkNA(props, 0x00000400, 0, false)
            }, {
                // tslint:disable-next-line:max-line-length
                Header: () => this.headerRenderer((<span>Video/Audio<br/>Sync<br/>Error</span>), 'Type: Count, Microsoft Smooth Stream Only <br /> Period: Session <br /> Detail: Video/audio are considered out of sync as measured by the video/audio synchronization threshold'),
                accessor: 'stream.statistics.files.media.video.videoAudioSyncErrors', // AV-SYNC
                id: 'videoAudioSyncError',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkNA(props, 0x00001000, 0, false)
            }, {
                Header: () => this.headerRenderer((<span>Decryption<br/>Error</span>), 'Type: Count, Apple AES Only <br /> Period: Session <br /> Detail: Media files that contain sync byte errors and/or missing PIDs after decryption.'),
                accessor: 'stream.statistics.files.media.decrypt.errors', // DECRYPT
                id: 'decryptionError',
                width: 90,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkNA(props, 0x00000800, 0, true)
            }
        ],
        [ 'Streaming Performance/Delivery' ]: [
            {
                Header: () => this.headerRenderer((<span>Media<br/>Files</span>), 'Type: Count <br /> Period: Session lifetime <br /> Detail: Downloaded media files'),
                accessor: 'stream.statistics.files.media.download.rate.samples',
                id: 'mediaFiles',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commaRenderer(props)
            }, {
                Header: () => this.headerRenderer((<span>Total<br/>KBytes<br/>Downloaded</span>), 'Type: Sum <br /> Period: Session lifetime <br /> Detail: Kilobytes of media files downloaded'),
                accessor: 'stream.statistics.files.media.totalBytes',
                id: 'totalKbytesDownloaded',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.bytesToKbRenderer(props)
            }, {
                Header: () => this.headerRenderer((<span>Media<br/>Bitrate</span>), 'Type: Average <br /> Period: <br /> Detail: Encoded bitrate'),
                accessor: 'stream.statistics.files.media.bitrate.avg',
                id: 'mediaBitrate',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.bytesToKbRenderer(props)
            }, {
                Header: () => this.headerRenderer((<span>Download<br/>Bit Rate<br/>(kbps)</span>), 'Type: Average <br /> Period: <br /> Detail: Download rate'),
                accessor: 'stream.statistics.files.media.download.rate.avg',
                id: 'downloadBitrate',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.renderBitRate(props)
            }, {
                // tslint:disable-next-line:max-line-length
                Header: () => this.headerRenderer((<span>Video<br/>Start<br/>Failure</span>), 'Type: Count <br /> Period: Session start <br /> Detail: Video Start Failure - Time from session start to first media file download exceeds threshold'),
                accessor: 'stream.statistics.timing.vsf', // VSF-TIME-EXCEED
                id: 'videoStartFailure',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x02000000, 1, false)
            }, {
                // tslint:disable-next-line:max-line-length
                Header: () => this.headerRenderer((<span>Derived<br/>Variant Start<br/>Time<br/>(ms)</span>), 'Type: Timed <br /> Period: Session start <br /> Detail: Time from session start until predicted playback start'),
                accessor: 'stream.statistics.timing.dvst', // DVST-TIME-EXCEED
                id: 'derivedVariantStartTime',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkMaster(props, 0x00800000, 1)
            }, {
                // tslint:disable-next-line:max-line-length
                Header: () => this.headerRenderer((<span>DV<br/>Start<br/>Time<br/>Exceeded</span>),  'Type: Count  <br /> Period: Session start <br /> Detail: Derived Video Start Time - Predicted playback start exceeds time threshold'),
                accessor: 'stream.statistics.timing.dvstErr', // DVST-TIME-EXCEED
                id: 'derivedVariantStartTimeExceeded',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkMaster(props, 0x00800000, 1)
            }, {
                Header: () => this.headerRenderer((<span>Download<br/>Time<br/>Exceeded<br/>Total</span>), 'Type: Count <br /> Period: Session lifetime <br /> Detail: Media file download time exceed playback duration'),
                accessor: 'stream.statistics.files.media.dltErr', // MF-DL-TIME-COUNT-WIN
                id: 'downloadTimeExceededTotal',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkMaster(props, 0x00004000, 0)
            }
        ],
        [ 'VOD Timeout' ]: [
            {
                Header: () => this.headerRenderer((<span>Outage<br/>Longer<br/>Than<br/>Timeout</span>), 'Type: Count <br /> Period: Session <br /> Detail: Stream is in ‘Outage’ state longer than timeout setting.'),
                accessor: 'stream.statistics.vod.timeoutTime', // VOD-TIMEOUT-OUTAGE
                id: 'vodTimeoutOutage',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.passFailRenderer(props, 'SYN-VOD-TIMEOUT-OUTAGE')
            }, {
                Header: () => this.headerRenderer((<span>Advance<br/>Test<br/>Exceeds<br/>Timeout</span>), 'Type: Count <br /> Period: Session <br /> Detail: The test time took too long and exceeds the configured time threshold.'),
                accessor: 'stream.statistics.vod.timeoutTime', // VOD-TIMEOUT-ADVANCE
                id: 'vodTimeoutAdvance',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.passFailRenderer(props, 'SYN-VOD-TIMEOUT-ADVANCE')
            }, {
                // tslint:disable-next-line:max-line-length
                Header: () => this.headerRenderer((<span>Full<br/>Test<br/>Exceeds<br/>Timeout</span>), 'Type: Count <br /> Period: Session <br /> Detail: The test took too long to complete and exceeds the content duration by more than the configured percentage.'),
                accessor: 'stream.statistics.vod.timeoutTime', // VOD-TIMEOUT-FULLSTREAM
                id: 'vodTimeoutFullstream',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.passFailRenderer(props, 'SYN-VOD-TIMEOUT-FULLSTREAM')
            }, {
                Header: () => this.headerRenderer((<span>Test<br/>Interrupted</span>), 'Type: Count <br /> Period: Session <br /> Detail: This test was interrupted when the VOD schedule ended.'),
                accessor: 'stream.statistics.vod.timeoutTime', // VOD-TIMEOUT-SCHEDULE
                id: 'vodTimeoutSchedule',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.passFailRenderer(props, 'SYN-VOD-TIMEOUT-SCHEDULE')
            }
        ],
        ['Media Quality']: [
            {
                Header: () => this.headerRenderer((<span>Video<br/>MOS<br/>(Avg)</span>), 'Type: Avg <br /> Period: Session <br /> Detail: Current opinion score (1-5) for video content'),
                accessor: 'stream.statistics.qoe.mos.video.avg', // QOE-MOSV-UNDLEV
                id: 'videoMosAvg',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00080000, 1)
            }, {
                Header: () => this.headerRenderer((<span>GOP<br/>MOS<br/>(Avg)</span>), 'Type: Avg <br /> Period: Session <br /> Detail: Mean opinion score (1-5)'),
                accessor: 'stream.statistics.qoe.mos.gop.avg',
                id: 'gopMosAvg',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x04000000, 1)
            }, {
                Header: () => this.headerRenderer((<span>Black<br/>Screen<br/>(Max)</span>), 'Type: Max <br /> Period: Session <br /> Detail: Current of the video frame that is black'),
                accessor: 'stream.statistics.qoe.gop.blackness.max', // QOE-BLACK-SCREEN
                id: 'blacknessMax',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00040000, 1)
            }, {
                Header: () => this.headerRenderer((<span>Still<br/>Frame<br/>(Min)</span>), 'Type: Min <br /> Period: Session <br /> Detail: Current of the video frame without motion'),
                accessor: 'stream.statistics.qoe.gop.stillness.min', // QOE-STILL-FRAME
                id: 'stillnessMin',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00020000, 1)
            }, {
                Header: () => this.headerRenderer((<span>Frame<br/>Error</span>), 'Type: Count <br /> Period: Session <br /> Detail: Media files that contain frame errors.'),
                accessor: 'stream.statistics.qoe.errors.frameErr', // SYN-FRAME-ERR
                id: 'frameErr',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkPixelMaster(props)
            }, {
                Header: () => this.headerRenderer((<span>Pixel<br/>Block<br/>Artifact</span>), 'Type: Count <br /> Period: Session <br /> Detail: Media files that contain pixel errors.'),
                accessor: 'stream.statistics.qoe.pixel.pixelErr', // QOE-PIXEL-BLK-ARTIFACT
                id: 'pixelErr',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00100000, 1)
            }, {
                Header: () => this.headerRenderer((<span>Audio<br/>MOS<br/>(Avg)</span>), 'Type: Avg <br /> Period: Session <br /> Detail: Current opinion score (1-5) for audio content'),
                accessor: 'stream.statistics.qoe.mos.audio.avg', // QOE-MOSA-UNDLEV
                id: 'audioMosAvg',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00000002, 1)
            }, {
                Header: () => this.headerRenderer((<span>Loudness<br/>(LKFS)<br/>(Min)</span>), 'Type: Min<br/>Period: Session<br/>Detail: Loudness K-weighted relative to full scale'),
                accessor: 'stream.statistics.qoe.audio.loudness.min', // QOE-LOUD-UNDLEV
                id: 'loudnessMin',
                width: 85,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x01000000, 1)
            }, {
                Header: () => this.headerRenderer((<span>Loudness<br/>(LKFS)<br/>(Max)</span>), 'Type: Max<br/>Period: Session<br/>Detail: Loudness K-weighted relative to full scale'),
                accessor: 'stream.statistics.qoe.audio.loudness.max', // QOE-LOUD-OVRLEV
                id: 'loudnessMax',
                width: 85,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00400000, 1)
            }, {
                Header: () => this.headerRenderer((<span>Dialnorm<br/>Deviation<br/>(Avg)</span>), 'Type: Avg <br/>Period: Session <br/>Detail: Measured loudness deviation from the received dialnorm metadata'),
                accessor: 'stream.statistics.qoe.audio.loudnessDnDev.avg', // QOE-DN-DEV-HIGH
                id: 'loudnessDnDevAvg',
                width: 85,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00000001, 0)
            }, {
                Header: () => this.headerRenderer((<span>Silence<br/>Channels</span>), 'Type: List <br /> Period: Session <br /> Detail: Audio channels detected'),
                accessor: 'stream.statistics.qoe.audio.silenceCh', // QOE-AUD-SILEN
                id: 'silenceCh',
                width: 150,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.countAudioChannel(props, 0x00000001, 1)
            // }, {
            //     Header: () => this.headerRenderer((<span>Silence<br/>Channel<br/>Error</span>), 'Type: Count<br/>Period: Last 10 seconds of audio<br/>Detail: Average dialog normalization level from the media'),
            //     accessor: 'stream.statistics.qoe.audio.silenceChErr', // QOE-AUD-SILEN
            //     id: 'silenceChErr',
            //     width: 85,
            //     align: 'right',
            //     aggregate: 'blank',
            //     Cell: (props: any) => this.checkQoEMedia(props, 0x00000001, 1)
            // }, {
            //     Header: () => this.headerRenderer((<span>Silence<br/>Error</span>), 'Type: Count<br/>Period: Last 10 seconds of audio<br/>Detail: Average dialog normalization level from the media'),
            //     accessor: 'stream.statistics.qoe.audio.silenceErr', // QOE-AUD-SILEN
            //     id: 'silenceErr',
            //     width: 85,
            //     align: 'right',
            //     aggregate: 'blank',
            //     Cell: (props: any) => this.checkQoEMedia(props, 0x00000001, 1)
            }
        ],
        [' ']: [
            {
                maxWidth: 12,
                align: 'center',
                sortable: false,
            }]
    };

    private seed: number = 1;

    calculateTimeout(props: any): React.ReactNode {
        let duration;

        if (props.original.stream.statistics && props.original.stream.statistics.summary) {
            duration = Renderers.timestamp.durationHMS(props.original.stream.statistics.summary.stopTime - props.original.stream.statistics.summary.startTime, false);
            if (props.original.stream.statistics.vod.timeoutErrType.length > 0) {
                return (
                    <div className="label-red">{this.displayTimeout(props.original.stream.statistics.vod.timeoutErrType)}</div>
                );
            } else {
                return (
                    <div>{duration}</div>
                );
            }
        } else {
            return(
                <div>-</div>
            );
        }
    }

    displayTimeout(value: any) {
        let retStr = '';
        switch (value[0]) {
            case 'outage':
                retStr = 'TIMEOUT: Stream in outage';
                break;
            case 'advance':
                retStr = 'TIMEOUT: Stream advance test too long';
                break;
            case 'full stream':
                retStr = 'TIMEOUT: Full stream test too long';
                break;
            case 'schedule mode':
                retStr = 'TIMEOUT: Schedule time exceeded';
                break;
            default:
                retStr = '-';
                break;
        }
        return retStr;
    }

    isSecureSite(): boolean {
        return window.location && window.location.protocol === 'https:';
    }

    random() {
        let x = Math.sin(this.seed++) * 10000;
        return x - Math.floor(x);
    }

    random_vs(n: number, _seed ?: number): Array<number> {
        n = Math.round(n);
        let v = new Array(n);
        if (_seed !== undefined)
            this.seed = _seed;
        for (let i = 0; i < n; i++) {
            v[i] = Math.log10(this.random() * 100000);
        }
        return v;
    }

    toggleColumn = (changeEvent: any) => {
        const { name } = changeEvent.target;

        this.setState(state => {
            const columns = state.columns.map((column: any) => {
                if (column.Header === name) {
                    column.show = !column.show;
                    return column;
                } else {
                    return column;
                }
            });
            return { columns };
        });
    }

    componentWillMount() {
        let host, imgurl, refreshRate, allCols;

        const groupSet = {set: ['Summary', 'Accessibility', 'ABR Protocol', 'Streaming Performance/Delivery',
                'VOD Timeout', 'Media Quality', ' ']};

        if (window.localStorage && (refreshRate = window.localStorage.getItem('refreshRate'))) {
            refreshRate = parseInt(refreshRate, 10);
        } else {
            refreshRate = 30000;
            window.localStorage.setItem('refreshRate', JSON.stringify(refreshRate));
        }

        if (window.localStorage && (allCols = window.localStorage.getItem('vodColumns'))) {
            let colsMatch = this.checkColumnsAgainstStoredColumns(this.columnSets, JSON.parse(allCols));
            if (!colsMatch) {
                window.localStorage.removeItem('vodColumns');
            }
        }

        if (window.localStorage && (allCols = window.localStorage.getItem('vodColumns'))) {
            this.setInitialColumns(this.columnSets, JSON.parse(allCols));
        } else {
            this.setDefaultColumns(this.columnSets, true);
        }

        this.setState({
            columns: groupSet.set,
            groupby: [],
            showAssets: false,
            showTestDetailsWindow: false,
            streamId: 0,
            streamName: '',
            streamFilter: '',
            statusFilter: '',
            formatFilter: '',
            showTopLevel: true,
            refreshRate: refreshRate,
            tempRefreshRate: 0,
            sharedManifest: false,
            streamType: '',
            masterFile: false,
            treeOrder: true,
            firstLoad: true,
            eventTypeFilter: [],
            eventTypeFilterText: [],
            eventTypeFilterAll: false,
            eventTypeClicked: false,
            showModal: false,
            audioEnabled: false,
            videoEnabled: false,
            pixelEnabled: false
        });
        this.setState({
          newColumns: [
              { Header: 'Name', accessor: 'username', show: true },
              {
                  Header: 'Status',
                  accessor: 'status',
                  show: true,
                  Cell: (props: any) => {
                      return <span className="number">{props.value}</span>;
                  }
              }
          ]
        });

        this.openTestDetailsWindow = this.openTestDetailsWindow.bind(this);
        this.setRefreshInterval = this.setRefreshInterval.bind(this);
        this.setRefreshIntervalInCache = this.setRefreshIntervalInCache.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);

        if (window.localStorage && (host = window.localStorage.getItem('host'))) {
            // tslint:disable-next-line:no-console
            console.log('determined host via local storage: ', host);
        } else
            host = window.location.host;

        imgurl = 'http://' + host;
        if (this.isSecureSite()) {
            imgurl = 'https://' + host;
        }

        this.setState({
            host,
            imgurl
        });
    }

    componentDidMount() {
        this.setAssetFilterOnFirstLoad();
        window.addEventListener('beforeunload', () => {
            this.closeTestDetailsWindowPortal();
        });
    }

    handleClick(object: any) {
        this.setState({
            showModal: true
        });
    }

    handleModalClose() {
        this.setState({
          showModal: false
        });
    }

    openTestDetailsWindow(props: any) {
        let result = props.original.stream && props.original.stream.statistics ? props.original.stream.statistics.summary.result : 'unknown';
        let message = props.original.stream && props.original.stream.statistics ? props.original.stream.statistics.summary.errors.binMnemArray : 'unknown';

        if (result !== 'unknown') {
            if (this.streamInOutage(props)) {
                result = 'OUTAGE';
            }
        }

        // SAN-4903
        window.localStorage.setItem('vodResults', JSON.stringify(props.original));

        this.setState({
            streamId: props.original.stream.id.vodId,
            streamName: props.original.stream.name,
            url: props.original.stream.statistics.summary.url,
            mode: 'VOD',
            streamResult: result,
            streamMessage: message,
            sharedManifest: (props.original.stream.status && props.original.stream.status.sharedManifest) ? props.original.stream.status.sharedManifest : false,
            streamType: props.original.stream.streamType,
            masterFile: props.original.stream.master,
            showModal: true,
            audioEnabled: props.original.stream.statistics.qoe.audioEnabled,
            videoEnabled: props.original.stream.statistics.qoe.videoEnabled,
            pixelEnabled: props.original.stream.statistics.qoe.pixelEnabled
        });
    }

    openTestDetailsWindowPortal() {
        this.setState(state => ({
            ...state,
            showTestDetailsWindow: true
        }));
    }

    closeTestDetailsWindowPortal() {
        this.setState({ showTestDetailsWindow: false });
    }

    setAssetFilterOnFirstLoad() {
        const { location } = this.props;
        // tslint:disable-next-line:no-unused-expression
        (this.state.firstLoad && location && location.state && location.state.streamName) && this.setState({streamFilter: location.state.streamName});
        this.setState({ firstLoad: false });
    }

    setRefreshInterval(interval?: number) {
        this.setState({ refreshRate: interval });
    }

    setRefreshIntervalInCache(interval?: number) {
        this.setState({ refreshRate: interval });
        if (!(interval === undefined)) {
            window.localStorage.setItem('refreshRate', JSON.stringify(interval));
        }
    }

    tooltipRenderer(): React.ReactNode {
        return <ReactTooltip effect="float" place="top" html={true} delayShow={500} offset={{top: 10, left: 10}} className="tool-tip-override-general"/>;
    }

    tooltipHeading(heading: any, text: any): React.ReactNode {
        return <ReactTooltip effect="float" place="top" html={true} delayShow={500} offset={{top: 10, left: 10}} className="tool-tip-override-general">{heading}</ReactTooltip>;
    }

    buttonRenderer(props: any): React.ReactNode {
        const result = props.original.stream && props.original.stream.statistics ? props.original.stream.statistics.summary.result : 'unknown';

        return (
            <div className="cellIcons">
                <Dropdown item icon="bars" >
                    <Dropdown.Menu>
                        <Dropdown.Item
                            onClick={() => this.openTestDetailsWindow(props)}
                            disabled={result === 'unknown' ? true : false}
                        >
                            Test Details
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    }

    getRowClassName(index: number) {
        if (index < 0) {
            return 'headerRow';
        } else {
            return index % 2 === 0 ? 'evenRow' : 'oddRow';
        }
    }

    streamInOutage(props: any) {
        return (props.original.stream.statistics.summary.outage.count > 0);
    }

    replaceAll(str: string, find: string, replace: string) {
        return str.replace(new RegExp(find, 'g'), replace);
    }

    statusRenderer(props: any): React.ReactNode {
        let clsName = 'status-chicklet ';
        let result = props.original.stream && props.original.stream.statistics ? props.original.stream.statistics.summary.result : 'unknown';
        let message = props.original.stream && props.original.stream.statistics ? props.original.stream.statistics.summary.errors.binMnemArray : 'unknown';
        message =  this.replaceAll(message.toString(), 'SYN-', '');

        if (result !== 'unknown') {
            if (this.streamInOutage(props)) {
                result = 'OUTAGE';
            }
        }

        switch (result) {
            case 'PASS': clsName += 'iq-td-status-clear'; break;      // Good        = Green
            case 'FAIL': clsName += 'iq-td-status-critical'; break;   // Fail        = Red
            case 'OUTAGE': clsName += 'iq-td-status-outage'; break;   // Outage      = Black
            default: clsName += 'iq-td-status-unknown'; break;        // Unknown     = Clear
        }

        return (
            <div data-tip={((result) ? result === 'PASS' ? 'Good' : result === 'FAIL' ? message : 'Outage' : 'Good' )}>
                {this.tooltipRenderer()}
                <span className={clsName}/>
            </div>
        );
    }

    streamTypeRenderer(props: any): React.ReactNode  {
        let name = props.value;
        if (name.startsWith('HLS')) {
            name = 'Apple HLS';
        } else if (name.startsWith('HDS')) {
            name = 'Adobe HDS';
        } else if (name.startsWith('DASH')) {
            name = 'MPEG DASH';
        } else if (name.startsWith('HSS')) {
            name = 'Microsoft Smooth Streaming';
        }

        return (
            <div>{name}</div>
        );
    }

    assetNameRenderer(props: any): React.ReactNode  {
        let clsName = 'td-colored-cell ';
        let master = props.original.stream ? props.original.stream.master : false;
        const result = props.original.stream && props.original.stream.statistics ? props.original.stream.statistics.summary.result : 'unknown';

        // determine how to display data for variants.
        if (master) {
            clsName += 'assetName';
        } else {
            clsName += 'variantName';
        }

        if (result === 'unknown') {
            return <div className={clsName} title={props.original.stream.name}> {props.original.stream.name} </div>;
        } else {
            return (
                <div className={clsName} title={'Click to display test result details'}>
                    <NavLink
                        to="#"
                        style={{ textDecoration: 'underline' }}
                        onClick={() => this.openTestDetailsWindow(props)}
                    >
                        {props.original.stream.name}
                    </NavLink>
                    {/*<a style={inlineStyle} href="#" onClick={() => this.openTestDetailsWindow(props)}>*/}
                    {/*    {props.original.stream.name}*/}
                    {/*</a>*/}
                    {/*<span onClick={() => this.openTestDetailsWindow(props)}>{props.original.stream.name}</span>*/}
                </div>
            );
        }
    }

    derivedVariantRenderer(props: any, bitMap: any, index: number): React.ReactNode {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }

        let clsName = '';
        let value = Renderers.secToMsec2(props.value);

        if (props.original.stream.statistics && props.original.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        return (
            <div className={clsName}>
                {value}</div>
        );
    }

    headerRenderer(header: any, headerText: string) {
        return (
            <div>
                <span data-tip={headerText} data-for="headerTip">
                    {header}
                </span>
                <ReactTooltip id="headerTip" place="top" effect="solid" html={true} />
            </div>
        );
    }

    commaRenderer(props: any): React.ReactNode {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let value = Renderers.commaSeparated(props.value);

        if (props.original.stream.master)
            value =  '-';
        return (
            <div>{value}</div>
        );
    }
    bytesToKbRenderer(props: any): React.ReactNode {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let value = Renderers.bytesToKB(props.value);
        if (props.original.stream.master)
            value =  '-';
        return (
            <div>{value}</div>
        );
    }

    renderBitRate(props: any): React.ReactNode {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let value = Renderers.bytesToKB(props.value);
        if (props.original.stream.master)
            value =  '-';
        return (
            <div>{value}</div>
        );
    }

    outageRenderer(props: any): React.ReactNode {
      let clsName = 'iq-td-status-clear';

      if ( props.original.stream.statistics.summary && props.original.stream.statistics.summary.outage.state === 1) {
        clsName = 'iq-td-status-outage';
        return (
          <div className={clsName}>{props.value.count} / {props.value.seconds}</div>
        );
      } else {
          return (
              <div className={clsName}>{0} / {0}</div>
          );
      }
    }

    checkPixelMaster(props: any): React.ReactNode {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let value = props.value;

        if (props.original.stream.statistics.qoe.pixelActive === false)
            value =  '-';
        return (
            <div>{value}</div>
        );
    }

    checkNotMaster(props: any, bitMap: any, index: number): React.ReactNode {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let clsName = '';
        let value = props.value;

        if (!props.original.stream.master) {
            value = '-'; clsName = '';
        } else {
            if (props.original.stream.statistics && props.original.stream.statistics.summary) {
                clsName = this.getAlarmHighlight(props, bitMap, index);
            }
        }

        if (value === undefined)
            value = '0';

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }
    commonAlarm0Renderer(props: any, bitMap: any, index: number): React.ReactNode {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let clsName = '';
        let value = props.value;

        if (props.original.stream.statistics && props.original.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        if (value === undefined)
            value = '0';

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }

    checkNA(props: any, bitMap: any, index: number, buffer: boolean): React.ReactNode  {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let clsName = '';
        let value = props.value;

        if (props.original.stream.statistics && props.original.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        if (value === '' || value === undefined) {
            value = 'missing';
            clsName = 'label-red';
        }

        if (props.original.stream.master)
            value = '-';
        if (props.value === 0)
            value = '-';

        const inlineStyle = {
            paddingRight: '10px'
        };

        return(
            <div className={clsName}>
                {buffer ? <span style={inlineStyle}> {value} </span> : value}
            </div>
        );
    }

    checkMediaType(props: any, bitMap: any, index: number, buffer: boolean): React.ReactNode {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let clsName = '';
        let value = props.value;

        if (props.original.stream.statistics && props.original.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        if (value === '' || value === undefined) {
            value = 'missing';
            clsName = 'label-red';
        }

        if (props.original.stream.master || (!(props.original.stream.status.media && props.original.stream.status.media.includes('text')))) {
            value =  '-'; clsName = '';
        }

        const inlineStyle = {
            paddingRight: '10px'
        };

        return(
            <div className={clsName}>
                {buffer ? <span style={inlineStyle}> {value} </span> : value}
            </div>
        );
    }

    checkMaster(props: any, bitMap: any, index: number): React.ReactNode  {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let clsName = '';
        let value;

        if (props.column.id === 'derivedVariantStartTime') {
            value = Renderers.secToMsec2(props.value);
        } else {
            value = props.value;
        }

        if (props.original.stream.statistics && props.original.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        if (props.column.id === 'iFrameMissing') {
            value = '-';  // Future
            clsName = ''; // 'label-blue'
        } else if (value === '' || value === undefined) {
            value = 'missing';
            clsName = 'label-red';
        }

        if (props.column.id === 'derivedVariantStartTimeExceeded' && (props.original.stream.status && props.original.stream.status.monitorMode && props.original.stream.status.monitorMode === 'Header Only')) {
            value = '-'; clsName = '';
        }

        if (props.original.stream.master) {
            value = '-'; clsName = '';
        }

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }
    checkVariant(props: any, bitMap: any, index: number, field: string): React.ReactNode  {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let value = '-';
        let clsName = '';

        if (props.original.stream.master) {
            if (props.original.stream.statistics && props.original.stream.statistics.summary) {
                clsName = this.getAlarmHighlight(props, bitMap, index);
            }
        }

        if (props.original.stream.master) {
            if (field === 'missing') {
                value =  props.original.stream.statistics.files && props.original.stream.statistics.files.manifest ? props.original.stream.statistics.files.manifest.varReqCnt : '-';
            } else if (field === 'total') {
                value =  props.original.stream.statistics.files && props.original.stream.statistics.files.manifest ? props.original.stream.statistics.files.manifest.varReqErr : '-';
            }
        }

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }
    checkVariantOrig(props: any, field: string): React.ReactNode  {
        let value = '-';

        if (props.original.stream.master) {
            if (field === 'missing') {
                value =  props.original.stream.statistics.files && props.original.stream.statistics.files.manifest ? props.original.stream.statistics.files.manifest.varReqCnt : '-';
            } else if (field === 'total') {
                value =  props.original.stream.statistics.files && props.original.stream.statistics.files.manifest ? props.original.stream.statistics.files.manifest.varReqErr : '-';
            }
        }
        return(
            <div>{value}</div>
        );
    }
    commaSeparated(props: any, value: any): React.ReactNode {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let parts = value.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return <span  className="right-aligned">{parts.join('.')}</span>;
    }
    httpCodesRenderer(props: any, value: any) {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        if (value === null || value === undefined) {
            return (
                <div>
                    <div className="http totals">
                        <div className="http2xxBox-empty">-</div>
                        <div className="http3xxBox-empty">-</div>
                        <div className="http4xxBox-empty">-</div>
                        <div className="http5xxBox-empty">-</div>
                        <div className="outline" data-tip="close">-</div>
                        <div className="outline" data-tip="socket and other">-</div>
                    </div>
                </div>);
        } else {
            return (
                <div
                    className="http totals"
                    title="2xx, 3xx, 4xx, 5xx http error counts, close errors and socket errors"
                >
                    <div className={(value.hss2xx === 0 || value.hss2xx === undefined) ? 'http2xxBox-empty' : 'http2xxBox'} title="2xx">{(value.hss2xx === 0 || value.hss2xx === undefined) ? '-' : this.commaSeparated(props, value.hss2xx)}</div>
                    {/* tslint:disable-next-line:max-line-length */}
                    <div className={(value.hsr3xxTotal === 0 || value.hsr3xxTotal === undefined) ? 'http3xxBox-empty' : 'http3xxBox'} title="3xx">{(value.hsr3xxTotal === 0 || value.hsr3xxTotal === undefined) ? '-' : this.commaSeparated(props, value.hsr3xxTotal)}</div>
                    {/* tslint:disable-next-line:max-line-length */}
                    <div className={(value.hsce4xxTotal === 0 || value.hsce4xxTotal === undefined) ? 'http4xxBox-empty' : 'http4xxBox'} title="4xx">{(value.hsce4xxTotal === 0 || value.hsce4xxTotal === undefined) ? '-' : this.commaSeparated(props, value.hsce4xxTotal)}</div>
                    {/* tslint:disable-next-line:max-line-length */}
                    <div className={(value.hsse5xxTotal === 0 || value.hsse5xxTotal === undefined) ? 'http5xxBox-empty' : 'http5xxBox'} title="5xx">{(value.hsse5xxTotal === 0 || value.hsse5xxTotal === undefined) ? '-' : this.commaSeparated(props, value.hsse5xxTotal)}</div>
                    <div className="http-close outline" title="close">{(value.close === 0 || value.close === undefined) ? '-' : this.commaSeparated(props, value.close)}</div>
                    <div className="http-other outline" title="socket and other">{(value.socketErrors === 0 || value.socketErrors === undefined) ? '-' : this.commaSeparated(props, value.socketErrors)}</div>
                </div>
            );
        }
    }
    checkMasterRenderer(props: any, buffer: boolean) {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let clsName = '';
        let value = props.value;

        if (value === '' || value === undefined) {
            value = 'missing';
            clsName = 'label-red';
        }

        if (props.original.stream.master)
            value = '-';

        const inlineStyle = {
            paddingRight: '10px'
        };

        return(
            <div className={clsName}>
                {buffer ? <span style={inlineStyle}> {value} </span> : value}
            </div>
        );
    }
    serverChangeRenderer(props: any) {
        if (!(props.original.stream.statistics)) {
            return '-';
        }
        if (props.original.stream.statistics && props.original.stream.statistics.connection) {
            // tslint:disable-next-line:max-line-length
            return (props.original.stream.statistics.connection && props.original.stream.statistics.connection.manifest ? props.original.stream.statistics.connection.manifest.IPChanges + ' / ' + props.original.stream.statistics.connection.media.IPChanges : '');
        } else {
            return '';
        }
    }
    commonTimeRenderer(props: any, bitMap: any, index: number): React.ReactNode {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let clsName = '';

        if (props.original.stream.statistics && props.original.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        return(
            <div className={clsName}>
                {(props.value / 1000).toFixed(3)}
            </div>
        );
    }

    commonMasterTimeRenderer(props: any, bitMap: any, index: number): React.ReactNode {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let clsName = '';

        if (props.original.stream.master)
            return '-';
        if (props.original.stream.statistics && props.original.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        return(
            <div className={clsName}>
                {props.value}
            </div>
        );
    }

    passFailRenderer(props: any, error: string): React.ReactNode {
        // In case there are no statistics yet.
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let result; let errorArray; let errorFound = false;
        let failed = false;

        // individual stream result
        result = props.original.stream.statistics.summary.result;

        if (!(result === 'PASS')) {
            if (error !== 'SYN-FRAME-ERROR') {
                errorArray = props.original.stream.statistics.summary.errors.binMnemArray;
                errorFound = errorArray.find((str: any) => str === error);
            } else {
                failed = props.value;
            }
        }

        // remove 'SYN-' from beginning of alarm for tooltip.
        if (error.startsWith('SYN-')) {
            error = error.substring(4);
        }

        if (!(errorFound || failed)) {
            return (
                <div>Pass</div>
            );
        } else {
            return (
                <div data-tip={error} className="label-red">
                    Fail
                    {this.tooltipRenderer()}
                </div>
            );
        }
    }

    getAlarmHighlight(props: any, bitMap: any, index: number) {
        let clsName = '';
        if (!(props.original.stream.statistics)) {
            return clsName;
        }
        let activeAlarmField = props.original.stream.statistics.summary.errors.active[index];
        let monitoredAlarmField = props.original.stream.statistics.summary.errors.mask[index];
        let historyAlarmField = props.original.stream.statistics.summary.errors.bin[index];

        // tslint:disable-next-line:no-bitwise
        if ((monitoredAlarmField & bitMap) !== 0) {
            // tslint:disable-next-line:no-bitwise
            if ((activeAlarmField & bitMap) !== 0) {
                clsName = 'iq-td-alarm-critical';
                // tslint:disable-next-line:no-bitwise
            } else if ((historyAlarmField & bitMap) !== 0) {
                clsName = 'iq-td-alarm-minr';
            } else {
                clsName = 'iq-td-status-clear';
            }
        } else {
            // tslint:disable-next-line:no-bitwise
            if ((historyAlarmField & bitMap) !== 0) {
                clsName = 'iq-td-alarm-minr';
            } else {
                clsName = '';
            }
        }

        return clsName;
    }

    countAudioChannel(props: any, bitMap: any, index: number): React.ReactNode {
        // audioFL?: boolean;  // 0x01  = 1
        // audioFC?: boolean;  // 0x02  = 2
        // audioFR?: boolean;  // 0x04  = 4
        // audioRL?: boolean;  // 0x10  = 16
        // audioRR?: boolean;  // 0x20  = 32
        // audioLFE?: boolean; // 0x100 = 256 (311 total)

        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }

        let clsName = '';
        let value = props.value;
        let audioString = '';

        switch (value) {
            case 0:
                audioString = '-';
                break;
            case 1:
                audioString = 'FL';
                break;
            case 2:
                audioString = 'FC';
                break;
            case 3:
                audioString = 'FL,FC';
                break;
            case 4:
                audioString = 'FR';
                break;
            case 5:
                audioString = 'FL,FR';
                break;
            case 6:
                audioString = 'FC,FR';
                break;
            case 7:
                audioString = 'FL,FC,FR';
                break;
            case 16:
                audioString = 'RL';
                break;
            case 17:
                audioString = 'FL,RL';
                break;
            case 18:
                audioString = 'FC,RL';
                break;
            case 19:
                audioString = 'FL,FC,RL';
                break;
            case 20:
                audioString = 'FR,RL';
                break;
            case 21:
                audioString = 'FL,FR,RL';
                break;
            case 22:
                audioString = 'FC,FR,RL';
                break;
            case 23:
                audioString = 'FL,FC,FR,RL';
                break;
            case 32:
                audioString = 'RR';
                break;
            case 33:
                audioString = 'FL,RR';
                break;
            case 34:
                audioString = 'FC,RR';
                break;
            case 35:
                audioString = 'FL,FC,RR';
                break;
            case 36:
                audioString = 'FR,RR';
                break;
            case 37:
                audioString = 'FL,FR,RR';
                break;
            case 38:
                audioString = 'FC,FR,RR';
                break;
            case 39:
                audioString = 'FL,FC,FR,RR';
                break;
            case 48:
                audioString = 'RL,RR';
                break;
            case 49:
                audioString = 'FL,RL,RR';
                break;
            case 50:
                audioString = 'FC,RL,RR';
                break;
            case 51:
                audioString = 'FL,FC,RL,RR';
                break;
            case 52:
                audioString = 'FR,RL,RR';
                break;
            case 53:
                audioString = 'FL,FR,RL,RR';
                break;
            case 54:
                audioString = 'FC,FR,RL,RR';
                break;
            case 55:
                audioString = 'FL,FC,FR,RL,RR';
                break;
            case 256:
                audioString = 'LFE';
                break;
            case 257:
                audioString = 'FL,LFE';
                break;
            case 258:
                audioString = 'FC,LFE';
                break;
            case 259:
                audioString = 'FL,FC,LFE';
                break;
            case 260:
                audioString = 'FR,LFE';
                break;
            case 261:
                audioString = 'FL,FR,LFE';
                break;
            case 262:
                audioString = 'FC,FR,LFE';
                break;
            case 263:
                audioString = 'FL,FC,FR,LFE';
                break;
            case 272:
                audioString = 'RL,LFE';
                break;
            case 273:
                audioString = 'FL,RL,LFE';
                break;
            case 274:
                audioString = 'FC,RL,LFE';
                break;
            case 275:
                audioString = 'FL,FC,RL,LFE';
                break;
            case 276:
                audioString = 'FR,RL,LFE';
                break;
            case 277:
                audioString = 'FL,FR,RL,LFE';
                break;
            case 278:
                audioString = 'FC,FR,RL,LFE';
                break;
            case 279:
                audioString = 'FL,FC,FR,RL,LFE';
                break;
            case 288:
                audioString = 'RR,LFE';
                break;
            case 289:
                audioString = 'FL,RR,LFE';
                break;
            case 290:
                audioString = 'FC,RR,LFE';
                break;
            case 291:
                audioString = 'FL,FC,RR,LFE';
                break;
            case 292:
                audioString = 'FR,RR,LFE';
                break;
            case 293:
                audioString = 'FL,FR,RR,LFE';
                break;
            case 294:
                audioString = 'FC,FR,RR,LFE';
                break;
            case 295:
                audioString = 'FL,FC,FR,RR,LFE';
                break;
            case 304:
                audioString = 'RL,RR,LFE';
                break;
            case 305:
                audioString = 'FL,RL,RR,LFE';
                break;
            case 306:
                audioString = 'FC,RL,RR,LFE';
                break;
            case 307:
                audioString = 'FL,FC,RL,RR,LFE';
                break;
            case 308:
                audioString = 'FR,RL,RR,LFE';
                break;
            case 309:
                audioString = 'FL,FR,RL,RR,LFE';
                break;
            case 310:
                audioString = 'FC,FR,RL,RR,LFE';
                break;
            case 311:
                audioString = 'FL,FC,FR,RL,RR,LFE';
                break;
            default:
                audioString = '-';
                break;
        }
        if (props.original.stream.statistics && props.original.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }
        if (props.original.stream.statistics.qoe.audioEnabled === false) {
            value = '-'; clsName = '';
        } else if (props.original.stream.statistics.qoe.audioEnabled === true && props.original.stream.statistics.qoe.audioActive === false) {
            value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
        } else {
            value = audioString;
        }
        return (
            <div className={clsName}>
                {value}
            </div>
        );
    }

    checkQoEMedia(props: any, bitMap: any, index: number): React.ReactNode {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let clsName = '';
        let value = props.value;

        if (value === '' || value === undefined) {
            value = 'missing';
            clsName = 'label-red';
        }

        if (props.original.stream.statistics && props.original.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        if (props.original.stream.statistics && props.original.stream.statistics.qoe) {
            if (props.column.id === 'videoMosAvg') {
                if (props.original.stream.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.stream.statistics.qoe.videoEnabled === true && props.original.stream.statistics.qoe.videoActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    if (props.value === 0) {
                        value = props.value;
                    } else {
                        value = props.value.toFixed(2);
                    }
                }
            } else if (props.column.id === 'gopMosAvg') {
                if (props.original.stream.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.stream.statistics.qoe.videoEnabled === true && props.original.stream.statistics.qoe.videoActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    if (props.value === 0) {
                        value = props.value;
                    } else {
                        value = props.value.toFixed(2);
                    }
                }
            } else if (props.column.id === 'audioMosAvg') {
                if (props.original.stream.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.stream.statistics.qoe.audioEnabled === true && props.original.stream.statistics.qoe.audioActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    if (props.value === 0) {
                        value = props.value;
                    } else {
                        value = props.value.toFixed(2);
                    }
                }
            } else if (props.column.id === 'loudnessMin' || props.column.id === 'loudnessMax') {
                if (props.original.stream.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.stream.statistics.qoe.audioEnabled === true && props.original.stream.statistics.qoe.audioActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    if (props.value === undefined) {
                        value = 0;
                    } else {
                        if (props.value === 0) {
                            value = props.value;
                        } else {
                            value = props.value.toFixed(2);
                        }
                    }
                }
            } else if (props.column.id === 'silenceCh' || props.column.id === 'silenceChErr' || props.column.id === 'silenceErr') {
                if (props.original.stream.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.stream.statistics.qoe.audioEnabled === true && props.original.stream.statistics.qoe.audioActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props.value;
                }
            } else if (props.column.id === 'loudnessDnDevAvg') {
                if (props.original.stream.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.stream.statistics.qoe.audioEnabled === true && props.original.stream.statistics.qoe.audioActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props.value;
                }
            } else if (props.column.id === 'stillnessMin') {
                if (props.original.stream.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.stream.statistics.qoe.videoEnabled === true && props.original.stream.statistics.qoe.videoActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props.value;
                }
            } else if (props.column.id === 'pixelErr') {
                if (props.original.stream.statistics.qoe.pixelEnabled === false) {
                    value = '-';
                    clsName = '';
                } else if (props.original.stream.statistics.qoe.pixelEnabled === true && props.original.stream.statistics.qoe.pixelActive === false) {
                    value = 'Unsupported Codec';
                    clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props.value;
                }
            } else if (props.column.id === 'blacknessMax') {
                if (props.original.stream.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.stream.statistics.qoe.videoEnabled === true && props.original.stream.statistics.qoe.videoActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props.value;
                }
            }
        } else {
            value = '-'; clsName = '';
        }

        const inlineStyle = {
            paddingRight: '10px'
        };

        if (props.column.id === 'loudnessDnDevAvg' && clsName !== 'iq-td-alarm-disabled') {
            return(
                <div className={clsName}>
                    <span style={inlineStyle}> {value} </span>
                </div>
            );
        } else {
            if (props.column.id === 'loudnessDnDevAvg' && clsName === 'iq-td-alarm-disabled') {
                return(
                    <div className={clsName} data-tip="Unsupported Codec">
                        {this.tooltipRenderer()}
                        <span style={inlineStyle}> - </span>
                    </div>
                );
            } else {
                if (clsName === 'iq-td-alarm-disabled') {
                    return (
                        <div className={clsName} data-tip="Unsupported Codec">
                            {this.tooltipRenderer()}
                            -
                        </div>
                    );
                } else {
                    return (
                        <div className={clsName}>
                            {value}
                        </div>
                    );
                }
            }
        }
    }

    commonAlarmRenderer(props: any, bitMap: any, index: number, buffer: boolean) {
        if (!(props.original.stream.statistics)) {
            return(
                <div>-</div>
            );
        }
        let clsName = '';
        let value = props.value;

        if (value === '' || value === undefined) {
            value = 'missing';
            clsName = 'label-red';
        }

        if (props.original.stream.statistics && props.original.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        const inlineStyle = {
            paddingRight: '10px'
        };

        return(
            <div className={clsName}>
                {buffer ? <span style={inlineStyle}> {value} </span> : value}
            </div>
        );
    }

    enabled(view: string): boolean {
        return _.includes(this.state.columns, view);
    }

    computeFilters() {
        let params = {};           // NOTE: 'streams' does not work for VOD. Only 'aliases' appears to work for VOD.
        let aliases = 'completed'; // DO NOT CHANGE! *** Note: The 'in-progress' filter does not supply the 'statistics' needed to display the column data.

        if (this.state.statusFilter !== '') {
            if (this.state.statusFilter === 'OUTAGE') {
                aliases += ' and outage';
            } else if (this.state.statusFilter === 'FAIL') {
                aliases += ' and alarmed';
            } else if ( this.state.statusFilter === 'PASS') {
                aliases += ' and good';
            }
        }

        if (this.state.formatFilter !== '') {
            if ( this.state.formatFilter === 'dash') {
                aliases += ' and dash';
            } else if ( this.state.formatFilter === 'hls') {
                aliases += ' and hls';
            } else if ( this.state.formatFilter === 'hss') {
                aliases += ' and hss';
            }
        }

        const { location } = this.props;
        let name = '';
        if (this.state.firstLoad && location && location.state && location.state.streamName) {
            name = (location.state.streamName.length > 0 ? location.state.streamName : '');
        } else {
            name = (this.state.streamFilter.length > 0 ? this.state.streamFilter : '');
        }

        if (name.length > 0) {
            if ((this.state.streamFilter.startsWith('\'') && this.state.streamFilter.endsWith('\'')) || (this.state.streamFilter.startsWith('\"') && this.state.streamFilter.endsWith('\"'))) {
                params = {
                    aliases: 'name and ' + aliases,
                    name: name
                };
            } else {
                // Adding name% to support partial string match
                params = {
                    aliases: 'name% and ' + aliases,
                    name: name
                };
            }
        } else {
            params = {
                aliases
            };
        }
        return params;
    }

    checkIfSectionColumnsAreChecked(colName: any, groupCols: any, allCols: any) {
        for (let index = 0; index < groupCols.length; index++) {
            for (const subkey in allCols[colName]) {
                if (groupCols[index].id === allCols[colName][subkey].id) {
                    if ( !allCols[colName][subkey].show) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    checkIfAllColumnsAreChecked(groupCols: any, allCols: any) {
        for (const section in groupCols) {
            if (!this.checkIfSectionColumnsAreChecked(groupCols[section].text, groupCols[section].columns, allCols)) {
                return false;
            }
        }
        return true;
    }

    handleCheckedColumn(data: any, colName: any, sumCol: any, allCols: any, index: any) {
        // let prevRefreshRate = this.state.refreshRate;
        // this.setRefreshInterval(1000);
        // setTimeout(() => this.setState({refreshRate: prevRefreshRate}), 2000);

        this.setState({tempRefreshRate: 1000});
        setTimeout(() => this.setState({tempRefreshRate: 0}), 2000);

        // allCols[colName][index] = {...allCols[colName][index], show: data.checked};

        for (const subkey in allCols[colName]) {
            if (sumCol.id === allCols[colName][subkey].id) {
                allCols[colName][subkey] = {...allCols[colName][subkey], show: data.checked};
            }
        }

        window.localStorage.setItem('vodColumns', JSON.stringify(allCols));

    }

    handleCheckedSectionColumn(data: any, colName: any, groupCols: any, allCols: any) {
        // let prevRefreshRate = this.state.refreshRate;
        // this.setRefreshInterval(1000);
        // setTimeout(() => this.setState({refreshRate: prevRefreshRate}), 2000);

        this.setState({tempRefreshRate: 1000});
        setTimeout(() => this.setState({tempRefreshRate: 0}), 2000);

        for (let index = 0; index < groupCols.length; index++) {
            this.handleCheckedColumn(data, colName, groupCols[index], allCols, index);
        }
    }

    handleUncheckSectionColumn(colName: any, groupCols: any, allCols: any, isQoE: any) {

        for (let index = 0; index < groupCols.length; index++) {
            allCols[colName][index] = {...allCols[colName][index], show: false};
        }
        if (isQoE) {
            for (const subkey in allCols['ABR Protocol']) {
                if ( allCols['ABR Protocol'][subkey].id === 'iFrameMissing') {
                    allCols['ABR Protocol'][subkey] = {...allCols['ABR Protocol'][subkey], show: false};
                }
            }
        }
    }

    handleAllColumnsChecked(data: any, groupCols: any, allCols: any) {
        // let prevRefreshRate = this.state.refreshRate;
        // this.setRefreshInterval(1000);
        // setTimeout(() => this.setState({refreshRate: prevRefreshRate}), 2000);

        this.setState({tempRefreshRate: 1000});
        setTimeout(() => this.setState({tempRefreshRate: 0}), 2000);

        for (let index = 0; index < groupCols.length; index++) {
            this.handleCheckedSectionColumn(data, groupCols[index].text, groupCols[index].columns, allCols);
        }
    }

    setDefaultColumns(allCols: any, initialLoad: any) {
        if (!initialLoad) {
            // let prevRefreshRate = this.state.refreshRate;
            // this.setRefreshInterval(1000);
            // setTimeout(() => this.setState({refreshRate: prevRefreshRate}), 2000);

            this.setState({tempRefreshRate: 1000});
            setTimeout(() => this.setState({tempRefreshRate: 0}), 2000);
        }

        // tslint:disable-next-line:forin
        for (const section in allCols) {
            let showCol = (section === 'Summary' || section === '_' || section === ' ') ? true : false;
            // tslint:disable-next-line:forin
            for (const subkey in allCols[section]) {
                allCols[section][subkey] = {...allCols[section][subkey], show: showCol};
            }
        }
        window.localStorage.setItem('vodColumns', JSON.stringify(allCols));
    }

    checkColumnsAgainstStoredColumns(columnSets: any, allCols: any) {
        let colStructuresMatch = true;

        // Checks the length of each section first
        for (const section in columnSets) {
            if (columnSets[section].length !== allCols[section].length) {
                colStructuresMatch = false;
            }
        }

        // If section lengths match, checks each column
        if (colStructuresMatch) {
            // tslint:disable-next-line:forin
            for (const section in columnSets) {
                for (const subkey in columnSets[section]) {
                    if (columnSets[section][subkey].id !== allCols[section][subkey].id) {
                        colStructuresMatch = false;
                    }
                }
            }
        }
        return colStructuresMatch;
    }

    setInitialColumns(columnSets: any, allCols: any) {
        // tslint:disable-next-line:forin
        for (const section in columnSets) {
            // tslint:disable-next-line:forin
            for (const subkey in columnSets[section]) {
                const showCol = allCols[section][subkey].show;
                columnSets[section][subkey] = {...columnSets[section][subkey], show: showCol};
            }
        }
    }

    checkIfColumnSelected(colName: any, id: any, allCols: any) {
        for (const subkey in allCols[colName]) {
            if (allCols[colName][subkey].id === id) {
                return allCols[colName][subkey].show;
                // console.log(allCols[colName][subkey]);
            }
        }
        return false;
    }

    render() {
        const stateOptions = [ { value: 'ALL', text: 'All' },
            { value: 'PASS', text: 'Good' },
            { value: 'FAIL', text: 'Fail' },
            { value: 'OUTAGE', text: 'Outage' }
        ];

        const formatOptions = [{value: '', text: 'All'}, {value: 'dash', text: 'DASH'}, {value: 'hls', text: 'HLS'}, {value: 'hss', text: 'HSS'}];

        let groupOptions = [
            {key: 'Summary', text: 'Summary', columns: [ // 2
                    { id: 'streamType', text: 'Stream Type'},
                    { id: 'duration', text: 'Duration'}
                ]
            }, {key: 'Accessibility', text: 'Accessibility', columns: [ // 12
                    { id: 'serverChanges', text: 'Server Changes'},
                    { id: 'dnsTime', text: 'DNS Time'},
                    { id: 'dnsTimeError15M', text: 'DNS  Time Error'},
                    { id: 'dnsQueryFailure15M', text: 'DNS Query Failure'},
                    { id: 'tcpConnectionTime', text: 'TCP Connection Time'},
                    { id: 'tcpConnectionTime15M', text: 'TCP Connection Time Error'},
                    { id: 'tcpConnectionFailure15M', text: 'TCP Connection Failure'},
                    { id: 'httpStatusCodes', text: 'HTTP Status Codes'},
                    { id: 'http4XxError15M', text: 'HTTP 4xx Error'},
                    { id: 'http5XxError15M', text: 'HTTP 5xx Error'},
                    { id: 'mimeHeaderErrors', text: 'MIME Header Error'},
                    { id: 'vodExpirationErr', text: 'Expired Asset Still Available'}
                ]
            }, {key: 'ABR Protocol', text: 'ABR Protocol', columns: [ // 13
                    { id: 'playlistUnavailable', text: 'Playlist Unavailable'},
                    { id: 'playlistFileError', text: 'Playlist File Error'},
                    { id: 'vodAssetTypeErr', text: 'Asset Type Incorrect'},
                    { id: 'variantCountError', text: 'Variant Count Error'},
                    { id: 'variantRequiredError', text: 'Variant Required Error'},
                    { id: 'mediaFileUnavailable', text: 'Media File Unavailable'},
                    { id: 'mediaFileDurationError15M', text: 'Media File Duration Error'},
                    { id: 'vodDurationError', text: 'Content Duration Error'},
                    { id: 'mediaFileBitrateError15M', text: 'Media File Bitrate Error'},
                    // { id: 'mediaFileTimeNotAligned', text: 'Media File Time Not Aligned'}, // MF-TIME-ALIGN // Not supported in VOD mode
                    { id: 'audioNotPresent', text: 'Audio Not Present'},
                    { id: 'videoAudioSyncError', text: 'Video/Audio Sync Error'},
                    { id: 'decryptionError', text: 'Decryption Error'}
                ]
            }, {key: 'Streaming Performance/Delivery', text: 'Streaming Performance/Delivery', columns: [ // 8
                    { id: 'mediaFiles', text: 'Media Files'},
                    { id: 'totalKbytesDownloaded', text: 'Total Kbytes Downloaded'},
                    { id: 'mediaBitrate', text: 'Media Bitrate'},
                    { id: 'downloadBitrate', text: 'Download Bitrate'},
                    { id: 'videoStartFailure', text: 'Video Start Failure'},
                    { id: 'derivedVariantStartTime', text: 'Derived Variant Start Time'},
                    { id: 'derivedVariantStartTimeExceeded', text: 'Derived Variant Start Time Exceeded '},
                    { id: 'downloadTimeExceededTotal', text: 'Download Time Exceeded Total'}
                ]
            }, {key: 'VOD Timeout', text: 'VOD Timeout', columns: [ // 4
                    { id: 'vodTimeoutOutage', text: 'Outage Longer Than Timeout'},
                    { id: 'vodTimeoutAdvance', text: 'Advance Test Exceeds Timeout'},
                    { id: 'vodTimeoutFullstream', text: 'Full Test Exceeds Timeout'},
                    { id: 'vodTimeoutSchedule', text: 'Test Interrupted'}
                ]
            }
        ];

        const qoeSection = {key: 'Media Quality', text: 'Media Quality', columns: [ // 12
            { id: 'videoMosAvg', text: 'Video Mos (Avg)'},
            { id: 'gopMosAvg', text: 'GOP MOS (Avg)'},
            { id: 'blacknessMax', text: 'Black Screen (Max)'},
            { id: 'stillnessMin', text: 'Still Frame (Min)'},
            { id: 'frameErr', text: 'Frame Error'},
            { id: 'pixelErr', text: 'Pixel Error'},
            { id: 'audioMosAvg', text: 'Audio MOS (Avg)'},
            { id: 'loudnessMin', text: 'Loudness (LKFS) (Min)'},
            { id: 'loudnessMax', text: 'Loudness (LKFS) (Max)'},
            { id: 'loudnessDnDevAvg', text: 'Dialnorm Deviation (Avg)'},
            { id: 'silenceCh', text: 'Silence Channels'}
            // { id: 'silenceChErr', text: 'Silence Channel Error'},
            // { id: 'silenceErr', text: 'Silence Error'}
        ]};

        const abrWithIframe = {key: 'ABR Protocol', text: 'ABR Protocol', columns: [ // 14
            { id: 'playlistUnavailable', text: 'Playlist Unavailable'},
            { id: 'playlistFileError', text: 'Playlist File Error'},
            { id: 'vodAssetTypeErr', text: 'Asset Type Incorrect'},
            { id: 'variantCountError', text: 'Variant Count Error'},
            { id: 'variantRequiredError', text: 'Variant Required Error'},
            { id: 'mediaFileUnavailable', text: 'Media File Unavailable'},
            { id: 'mediaFileDurationError15M', text: 'Media File Duration Error'},
            { id: 'vodDurationError', text: 'Content Duration Error'},
            { id: 'mediaFileBitrateError15M', text: 'Media File Bitrate Error'},
            // { id: 'mediaFileTimeNotAligned', text: 'Media File Time Not Aligned'}, // MF-TIME-ALIGN // Not supported in VOD mode
            { id: 'iFrameMissing', text: 'I-Frame Missing'},
            { id: 'audioNotPresent', text: 'Audio Not Present'},
            { id: 'videoAudioSyncError', text: 'Video/Audio Sync Error'},
            { id: 'decryptionError', text: 'Decryption Error'}
        ]};

        const inlineStyle = {
            modal : {
                marginTop: '50px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };

        let allColumns = this.columnSets;

        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                    if (oauth.QoELicensePresent) {
                        groupOptions = [...groupOptions.slice(0, 2), abrWithIframe, ...groupOptions.slice(3), qoeSection];
                    } else {
                        this.handleUncheckSectionColumn(qoeSection.text, qoeSection.columns, allColumns, true);
                    }

                    return (
                        <React.Fragment>
                            <div className="pageTitle displayflex">
                                    <div className="page-title-block">
                                        <div className="iq-temp-key-val">
                                            <div className="iq-temp-val page-title-text">VOD Census</div>
                                        </div>
                                    </div>
                                <div className="floatRight">
                                    <UpdateList
                                        refresh={this.state.refreshRate}
                                        onChange={(interval: number | undefined, enabled: boolean) => this.setRefreshIntervalInCache(interval)}
                                    />
                                </div>
                            </div>
                            <div className="filterPanel">
                                <Input
                                    className="censusPageSearchBox"
                                    placeholder="VOD Asset Alias"
                                    value={this.state.streamFilter}
                                    onChange={(event, data) => this.setState({streamFilter: data.value})}
                                    icon={!this.state.streamFilter ? <Icon /> : <Icon name="delete" link onClick={() => this.setState({streamFilter: ''})} />}
                                />
                                <Dropdown
                                    className="censusDropDown"
                                    placeholder="State"
                                    clearable
                                    search
                                    // disabled
                                    selection
                                    options={stateOptions}
                                    value={this.state.statusFilter}
                                    onChange={(event, data) => this.setState({statusFilter: data.value})}
                                />
                                <Dropdown
                                    className="censusDropDown"
                                    placeholder="Type"
                                    clearable
                                    search
                                    selection
                                    options={formatOptions}
                                    // disabled
                                    value={this.state.formatFilter}
                                    onChange={(event, data) => this.setState({formatFilter: data.value})}
                                />
                                <Dropdown
                                    className="censusDropDown floatRight censusDropDownColumns"
                                    placeholder="Columns"
                                    // multiple
                                    selection
                                    search
                                    labeled={false}
                                    searchInput={false}
                                    direction={'left'}
                                    wrapSelection
                                    floating
                                    text="Columns"
                                >
                                    <Dropdown.Menu className="censusDropDownColumnsMenu" >
                                        <div className="spacerFS"/>
                                        <Checkbox
                                            className="filter-panel-checkbox"
                                            label={<label className="" style={{backgroundColor: 'rgba(255,255,255, 0)'}}>
                                                {'All Columns'}
                                            </label>}
                                            style={{marginLeft: '35px'}}
                                            name={'All Columns'}
                                            checked={this.checkIfAllColumnsAreChecked(groupOptions, allColumns)}
                                            onChange={(e: any, data: any) => this.handleAllColumnsChecked(data, groupOptions, allColumns)}
                                        />
                                        <Button
                                            className="filterPanel-primary-btn floatRight"
                                            content="Reset to Default"
                                            onClick={() => this.setDefaultColumns(allColumns, false)}
                                            style={{marginRight: '75px'}}
                                        />
                                        <div className="spacerFS"/>
                                        {groupOptions.map(cols => {
                                            return <React.Fragment>
                                                <fieldset className="field-set censusDropDownColumnsFieldset" >
                                                    <legend>
                                                <span style={{marginLeft: '5px'}} >
                                                    {/* tslint:disable-next-line:jsx-alignment */}
                                                <Checkbox key={cols.text}
                                                          label={<label className="" style={{backgroundColor: 'rgba(255,255,255, 0)'}}>
                                                              {cols.text}
                                                          </label>}
                                                          name={cols.text}
                                                          checked={this.checkIfSectionColumnsAreChecked(cols.text, cols.columns, allColumns)}
                                                          onChange={(event, data) => this.handleCheckedSectionColumn(data, cols.text, cols.columns, allColumns)}

                                                />
                                                </span>
                                                    </legend>
                                                    <Grid columns={4} >
                                                        {cols.columns.map((sumCol, index) => {
                                                            // tslint:disable-next-line:jsx-key
                                                            return <Grid.Column><Dropdown.Item>
                                                                {/* tslint:disable-next-line:jsx-alignment */}
                                                                <Checkbox key={sumCol.text}
                                                                          label={<label className="" style={{backgroundColor: 'rgba(255,255,255, 0)'}}>
                                                                              {sumCol.text}
                                                                          </label>}
                                                                          name={sumCol.text}
                                                                          checked={this.checkIfColumnSelected(cols.text, sumCol.id, allColumns)}
                                                                          onChange={(event, data) => this.handleCheckedColumn(data, cols.text, sumCol, allColumns, index)}
                                                                          style={{width: '100%'}}
                                                                />
                                                            </Dropdown.Item></Grid.Column>;
                                                        })}
                                                    </Grid></fieldset>
                                                <div className="spacerFS"/>
                                            </React.Fragment>;
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>

                                {/*<PortalView size="fullscreen" modal={true} active={this.state && this.state.showTestDetailsWindow} closeWindowPortal={this.closeTestDetailsWindowPortal}>*/}
                                {/* tslint:disable-next-line:max-line-length */}
                                {/*    <TestDetailsView streamResult={this.state.streamResult} streamId={this.state.streamId} streamName={this.state.streamName} url={this.state.url} sharedManifest={this.state.sharedManifest} streamType={this.state.streamType} masterFile={this.state.masterFile} mode={this.state.mode}/>*/}
                                {/*</PortalView>*/}

                                <Modal
                                    open={this.state.showModal}
                                    centered={false}
                                    dimmer="blurring"
                                    size="fullscreen"
                                    style={inlineStyle.modal}
                                    onClose={this.handleModalClose}
                                    className="portal-view"
                                >
                                    <div className="modal-icons">
                                        <FontAwesome name="times" onClick={this.handleModalClose} />
                                    </div>
                                    <Modal.Header>{this.state.streamName}</Modal.Header>
                                    <Modal.Content scrolling>
                                        {/* tslint:disable-next-line:max-line-length */}
                                        <TestDetailsView
                                            streamMessage={this.state.streamMessage}
                                            streamResult={this.state.streamResult}
                                            streamId={this.state.streamId}
                                            streamName={this.state.streamName}
                                            url={this.state.url}
                                            sharedManifest={this.state.sharedManifest}
                                            streamType={this.state.streamType}
                                            masterFile={this.state.masterFile}
                                            mode={this.state.mode}
                                            audioEnabled={this.state.audioEnabled}
                                            videoEnabled={this.state.videoEnabled}
                                            pixelEnabled={this.state.pixelEnabled}
                                        />
                                    </Modal.Content>
                                </Modal>
                            </div>
                            <div className="view-clientarea">
                                <VodDataExportView
                                    columnSets={allColumns}
                                    // columnSets={this.columnSets}
                                    groups={this.state.columns}
                                    filter={this.state.censusFilter}
                                    refreshRate={this.state.tempRefreshRate === 0 ? this.state.refreshRate: this.state.tempRefreshRate}
                                    streamName={this.state.streamFilter}
                                    // setFilter={this.state.setFilter}
                                    statusFilter={this.state.statusFilter}
                                    formatFilter={this.state.formatFilter}
                                    // initiatorFilter={this.state.initiatorFilter}
                                    showTopLevel={this.state.showTopLevel} // true
                                    filters={this.computeFilters()}
                                    // onDataUpdated={this.onDataUpdated}
                                    treeOrder={this.state.treeOrder} // true
                                />
                            </div>
                        </React.Fragment>
                    );
                }}
            </OAuth.Context>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/vodCensus.tsx